'use client'

import type React from 'react'

import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { FormattedMessage } from '@b-stock/fe-core/bstock-react'

import { useAuctionQuery } from '@/helpers/useAuctionQuery'

import { Inner, Section } from './ui'

export function ClosingSoonTitle() {
  return <FormattedMessage id="LoggedOutHomepage.closingSoon.title" />
}

export function ClosingSoonViewMoreLabel() {
  return (
    <>
      <FormattedMessage id="LoggedOutHomepage.closingSoon.viewMore" />
      <FontAwesomeIcon icon={faArrowRight} />
    </>
  )
}

export default function ClosingSoonSection({
  endpoint,
  children,
}: {
  endpoint: string
  children: React.ReactNode
}) {
  // Same query as the carousel, so the section leaves with it when a refetch comes back empty.
  const { data: listings, isLoading } = useAuctionQuery(endpoint)
  if (!isLoading && !listings?.length) {
    return null
  }

  return (
    <Section data-testid="logged-out-closing-soon">
      <Inner>{children}</Inner>
    </Section>
  )
}
